import { Search } from "history";
import {
  GetEmployeeProfilesQueryProps,
  initialQueryProps,
  startingPage,
} from "Shared/types/EmployeeProfiles";
import { UserTableSort } from "Shared/types/Sort";
import { UserStatus, EmploymentStatus, Benefit } from "Shared/types/EmployeeProfiles";

export default function queryToProps(
  search: Search
): GetEmployeeProfilesQueryProps {
  const params = new URLSearchParams(search);
  const pageParam = params.get("page");

  let searchParam = params.get("search") || "";
  searchParam = decodeURIComponent(searchParam);

  return {
    page: pageParam ? +pageParam : startingPage,
    search: searchParam,
    userStatusFilters: splitAdvancedFilter(
      params.get("userStatus")
    ) as UserStatus[],
    locationFilters: splitAdvancedFilter(params.get("location")),
    payGroupFilters: splitAdvancedFilter(params.get("payGroup")),
    employmentStatusFilters: splitAdvancedFilter(
      params.get("employmentStatus")
    ) as EmploymentStatus[],
    benefitFilters: splitAdvancedFilter(
      params.get("benefitType")
    ) as Benefit[],
    sort: getPropsFromSort(params.get("sort")),
  };
}

const splitAdvancedFilter = (param: string | null) =>
  param ? param.split(",") : [];

function getPropsFromSort(sortStringWithCommas: string | null): UserTableSort {
  if (sortStringWithCommas === null) return initialQueryProps.sort;
  const splitSortString = sortStringWithCommas.split(",");
  return [splitSortString[0], splitSortString[1]] as UserTableSort;
}
